import React from 'react';
import {ChekinSDKContext} from './ChekinSDKProvider';

export function useChekinSDK() {
  const context = React.useContext(ChekinSDKContext);
  if (context === undefined) {
    throw new Error('useReservation must be used within a ChekinSDKProvider');
  }

  return context;
}
